import { useMemo } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps, Grid } from '@mantine/core'
import { useIntl } from 'react-intl'

import { useIsMobile } from 'hooks/useIsMobile'
import { Category } from 'interfaces/types'

import useStyles from './index.styles'
import { Item } from './item'
import { CarouselOrListingBlockWrapper } from '../../carouselOrListingBlockWrapper'

type Props = {
  categories?: Category[]
} & BoxProps

export const Categories = ({
  categories = [],
  styles,
  className,
  classNames,
  ...boxProps
}: Props) => {
  const { classes, cx, theme } = useStyles(undefined, {
    name: 'ArticleCardList__Categories',
    styles,
    classNames,
  })
  const { formatMessage: f } = useIntl()
  const isMobile = useIsMobile()
  const listLength = useMemo(() => categories.length, [categories])
  const perSlide = useMemo(() => (isMobile ? 6 : 1), [isMobile])
  const slideGroup = useMemo(
    () =>
      new Array(Math.ceil(listLength / perSlide))
        .fill('')
        .map((_i, idx) =>
          categories.slice(idx * perSlide, idx * perSlide + perSlide),
        ),
    [isMobile],
  )
  return categories.length > 0 ? (
    <Box className={cx(className, classes.root)} {...boxProps}>
      <Text size="h3">
        {f({ id: 'articlePage.relatedCategoriesListSectionTitle' })}
      </Text>
      {isMobile ? (
        <CarouselOrListingBlockWrapper
          lengthToCarouselMobile={2}
          lengthToCarouselDesktop={5}
          showFullSlide
          carouselSetting={{
            loop: false,
          }}
        >
          <CarouselOrListingBlockWrapper.Slider>
            {slideGroup.map((item, itemIdx) => (
              <Grid
                justify={
                  slideGroup.length === 1 && item.length === 1
                    ? 'center'
                    : undefined
                }
                grow={slideGroup.length > 1 && item.length > 1}
                gutterMd={24}
                gutterXs={0}
                key={itemIdx}
                sx={{
                  [theme.fn.smallerThan('sm')]: {
                    height: 'auto !important',
                  },
                }}
              >
                {item.map((i, idx) => (
                  <Grid.Col span={isMobile ? 4 : 12} key={idx}>
                    <Box key={idx} className={classes.slider}>
                      <Item data={i} />
                    </Box>
                  </Grid.Col>
                ))}
              </Grid>
            ))}
          </CarouselOrListingBlockWrapper.Slider>
        </CarouselOrListingBlockWrapper>
      ) : (
        <CarouselOrListingBlockWrapper
          lengthToCarouselMobile={2}
          lengthToCarouselDesktop={5}
          showFullSlide
        >
          <CarouselOrListingBlockWrapper.Slider>
            {categories.map((i, idx) => (
              <Box key={idx} className={classes.slider}>
                <Item data={i} />
              </Box>
            ))}
          </CarouselOrListingBlockWrapper.Slider>
        </CarouselOrListingBlockWrapper>
      )}
    </Box>
  ) : null
}
